import antdVi from 'antd/lib/locale-provider/vi_VN';
import appLocaleData from 'react-intl/locale-data/vi';
import viMessages from './locales/vi.json';

window.appLocale = {
  messages: {
    ...viMessages,
  },
  antd: antdVi,
  locale: 'vi-VN',
  data: appLocaleData,
};



// WEBPACK FOOTER //
// ./src/vi-VN.js